import { useTranslation } from "react-i18next";

export function HowToRoute() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <h1 className="text-2xl font-bold text-fg">{t("howto.title")}</h1>

      <ol className="mt-6 space-y-6">
        {(["find", "check", "report", "favorite", "add"] as const).map((step, i) => (
          <li key={step} className="flex gap-4">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-bg-deep text-sm font-bold text-fg">
              {i + 1}
            </span>
            <div>
              <p className="font-semibold text-fg">{t(`howto.steps.${step}.title`)}</p>
              <p className="mt-1 text-sm text-fg-mute">{t(`howto.steps.${step}.body`)}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
